import React, { Component, Suspense } from "react";
import { withAlert } from "react-alert";
import { withTranslation } from "react-multi-lang";
import { NavLink, Redirect } from "react-router-dom";
import { replacestate } from "./../../../redux_store/actions/index";
import {
    defalutreduxState,
    isMultitenant
} from "./../../../custom_functions/Constance.jsx";
import store from "./../../../redux_store/store/index";
import "rc-tabs/assets/index.css";
import Tabs, { TabPane } from "rc-tabs";
import { AtTabs } from "./../../../controls/custom-tabs.styles";
import { ControlRights, getModuleRihtsOnOrderModule, Servicecallforuserrightscallback, SubMenuRightsonScreenViews } from "../../../custom_functions/Functions";

const Menu = React.lazy(() => import("./../../Menu.jsx"));
const ApplicationHeader = React.lazy(() => import("./../../general/ApplicationHeader.jsx"));
const ApplicationFooter = React.lazy(() => import("./../../general/ApplicationFooter.jsx"));

const Reportviewer = React.lazy(() => import("./../../reports/Reportviewer.tsx"));

class PReportviewer extends Component {
    constructor(props) {
        super(props);
        this.ELNurl = window.appUrl.ELN;
        this.state = {
            validurl: true,
            MenuGroup: "DownloadReport",
            ChildMenu: "SheetViewcss",
            PageName: this.props.t("Reports.IDS_LBL_SCREENNAME", { param: "" }),
            Menuselected: ""
        }
    }

    MainMeunClick(Menu) {
        let PageName = "";
        let open = false;
        if (Menu === "SheetCreation") {
            PageName = this.props.t("Templates.Sheettemplates.IDS_LBL_SHEETCREATION", {
                param: "",
            });
            open = false;
        } else if (Menu === "SheetView") {
            PageName = this.props.t("Orders.Sheetorders.IDS_LBL_SHEETORDERS");
            open = false;
        } else if (Menu === "SheetSetting") {
            PageName = this.props.t("menu.IDS_SHEETSETTING", {
                param: "",
            });
        } else if (Menu === "AuditTrail") {
            PageName = this.props.t("AuditTrail.ID_AUDITTRAIL", {
                param: "",
            });
            open = false;
        } else if (Menu === "UserManagement") {
            PageName = this.props.t("UserManagement.ID_USERMANAGEMENT", {
                param: "",
            });
            open = false;
        } else if (Menu === "Dashboard") {
            PageName = this.props.t("Dashboard.IDS_LBL_DASHBOARD", {
                param: "",
            });
            open = false;
        } else if (Menu === "Masters") {
            PageName = this.props.t("Masters.ID_MASTERS", {
                param: "",
            });
            open = false;
        } else if (Menu === "DownloadReport") {
            PageName = this.props.t("Reports.IDS_LBL_SCREENNAME", {
                param: "",
            });
            open = false;
        }

        this.setState({
            MenuGroup: Menu,
            PageName: PageName,
            open: open || true,
            Menuselected: "",
        });
    }
    // componentDidMount() {
    //     setTimeout(() => {
    //         let Reportdesigner = ControlRights("IDS_MDL_REPORTS", "IDS_SCN_REPORTDESIGNER");
    //         let Reportviewer = ControlRights("IDS_MDL_REPORTS", "IDS_SCN_REPORTVIEWER");
    //         let reportTemplate = ControlRights("IDS_MDL_REPORTS", "IDS_TSK_REPORTMAPPING");
    //         this.setState({
    //             Reportviewer: Reportviewer.UserGroupRights.rights,
    //             Reportdesigner: Reportdesigner.UserGroupRights.rights,
    //             ReportTemplateMapping: reportTemplate.UserGroupRights.rights,

    //             Reportviewersave: true,
    //             Reportviewernewfolder: true,
    //         })
    //     }, 250);
    // }

    ChilMenuclick(Menu) {
        this.setState({ ChildMenu: Menu });
    }

    onredirectrights(objrights) {
        if (!store.getState().Menu?.Controlrights?.rights) {
            Servicecallforuserrightscallback("" + this.ELNurl + "/User/GetUserRightsonUser",
                {
                    usercode: sessionStorage.User,
                    lsusergroup: { usergroupcode: sessionStorage.multiusergroups },
                },
                () => this.setScreenView(objrights)
            );
        } else {
            this.setScreenView(objrights);
        }
    }

    setScreenView(objrights) {
        let Reportdesigner = SubMenuRightsonScreenViews("IDS_MDL_REPORTS", "IDS_SCN_REPORTS");
        let Reportviewer = SubMenuRightsonScreenViews("IDS_MDL_REPORTS", "IDS_SCN_REPORTVIEVER");
        let reportTemplate = SubMenuRightsonScreenViews("IDS_MDL_REPORTS", "IDS_SCN_REPORTMAPPER");

        this.setState({
            validurl: SubMenuRightsonScreenViews("IDS_MDL_REPORTS", "IDS_SCN_REPORTVIEVER"),
            userrightdetails: objrights,
            Reportviewer: Reportviewer,//Reportviewer.UserGroupRights.rights,
            Reportdesigner: Reportdesigner,
            ReportTemplateMapping: reportTemplate,
            Reportviewersave: true,
            Reportviewernewfolder: true,
        });
    }

    onlogoutSuccess(response) {
        store.dispatch(replacestate(defalutreduxState));
        setTimeout(() => {
            let tenantdomain = sessionStorage.getItem("tenantdomain");

            if (tenantdomain !== undefined) {
                isMultitenant === 0
                    ? this.props.history.push("/")
                    : this.props.history.push("/#" + tenantdomain);
                this.props.alert.success(this.props.t("Login.IDS_MSG_LOGOUT"));
            } else {
                this.props.history.push("/")
            }
        }, 100);
    }

    redirecttohome() {
        this.props.history.push("/Home");
    }

    onlogoutFailure(response) { }

    render() {
        if (!sessionStorage?.User) {
            return isMultitenant === 2 ? (
                <Redirect to="/" />
            ) : isMultitenant === 0 ? (
                <Redirect to="/" />
            ) : (
                <Redirect to={"/#" + sessionStorage?.tenantdomain} />
            );
        }

        if (!this.state.validurl) {
            const getPath = getModuleRihtsOnOrderModule("IDS_MDL_SETUP");
            console.log(getPath);

            let path = getPath?.path !== undefined ? getPath?.path : "/Home";

            return <Redirect to={path} />;
        }

        return (
            <div id="idElnBody">
                <Suspense fallback={<div></div>}>
                    <Menu
                        sendData={this.MainMeunClick}
                        childmenuclick={this.ChilMenuclick.bind(this)}
                        selected={this.state.Menuselected}
                        menugroup={this.state.MenuGroup}
                        redirectrights={this.onredirectrights.bind(this)}
                    />
                </Suspense>
                <div id="bodycontent" className="d-flex flex-column">
                    <Suspense fallback={<div></div>}>
                        <ApplicationHeader
                            onlogoutSuccess={this.onlogoutSuccess.bind(this)}
                            redirecttohome={this.redirecttohome.bind(this)}
                            onlogoutFailure={this.onlogoutFailure.bind(this)}
                            PageName={this.state.PageName}
                        />
                    </Suspense>
                    <AtTabs>
                        <Tabs
                            activeKey={"2"}
                            onTabClick={this.ontabclick}
                            moreIcon={<span className="moreDot">...</span>}
                        >
                            {this.state.Reportdesigner ?
                                <TabPane
                                    tab={
                                        <NavLink
                                            to={{ pathname: "/reportdesigner", state: {} }}
                                            title={this.props.t("Reports.IDS_SCN_REPORTVIEWER", {})}
                                        >
                                            {this.props.t("Reports.IDS_SCN_REPORTDESIGNER", {})}
                                        </NavLink>}
                                    key="1"
                                >
                                </TabPane>
                                : false}
                            {this.state.Reportviewer ?
                                <TabPane
                                    tab={this.props.t("Reports.IDS_SCN_REPORTVIEWER", {})}
                                    key="2"
                                >
                                    <Suspense>
                                        <Reportviewer sessionvalues={{
                                            usercode: sessionStorage.getItem("User"),
                                            username: sessionStorage.getItem("Username"),
                                            lssitemaster: { sitecode: sessionStorage.getItem("Usersite") },
                                            lsuserMaster: {
                                                usercode: sessionStorage.getItem("User"),
                                                username: sessionStorage.getItem("Username"),
                                            },
                                            token: sessionStorage.getItem("Token"),
                                            tenant: sessionStorage.getItem("tenantid"),
                                            Reportviewersave: this.state.Reportviewersave,
                                            Reportviewernewfolder: this.state.Reportviewernewfolder,
                                        }} />
                                    </Suspense>
                                </TabPane>
                                : false}

                            {this.state.ReportTemplateMapping ?
                                <TabPane
                                    tab={
                                        <NavLink
                                            to={{ pathname: "/reportMapping", state: {} }}
                                            title={this.props.t("Reports.IDS_SCN_REPORTMAPPER", {})}
                                        >
                                            {this.props.t("Reports.IDS_SCN_REPORTMAPPER", {})}
                                        </NavLink>}
                                    key="3"
                                >
                                </TabPane>
                                : false}
                        </Tabs>
                    </AtTabs>
                </div>
                <Suspense fallback={<div></div>}>
                    <ApplicationFooter
                        onlogoutSuccess={this.onlogoutSuccess.bind(this)}
                        onlogoutFailure={this.onlogoutFailure.bind(this)}
                        onforgot={this.props.onforgot}
                    />
                </Suspense>
            </div>
        );
    }
}
export default withAlert()(withTranslation(PReportviewer));